import React from 'react';
import './BaseInfomation.less';
// import { useLocation } from 'umi';
import { useSelector } from 'dva';
import { useIntl } from 'umi';
import { Box } from '@material-ui/core';

const BaseInfomation = () => {
  //过于国际化的方法
  const intl = useIntl();
  const { formatMessage } = intl;
  // const location = useLocation();
  // const { query } = location;
  //保持状态
  // const { tab } = query;
  // const { datas } = props;
  const datas = useSelector((state) => state.ml.getMemberDetail);
  const {
    name,
    mobile = '',
    level,
    memberCode,
    gender,

    // status,
  } = datas || {};
  const genderObj = {
    F: '女',
    M: '男',
    U: '未知',
  };
  return (
    <Box>
      <Box className="box">
        <Box className="item">
          <div className="up">
            {formatMessage({ id: 'cm.member.detail.n01.lbl01' })}
          </div>
          <div className="down">{name}</div>
        </Box>
        <Box className="item">
          <div className="up">
            {formatMessage({ id: 'cm.member.detail.n01.lbl02' })}
          </div>
          <div className="down">{genderObj[gender]}</div>
        </Box>
        <Box className="item">
          <div className="up">
            {formatMessage({ id: 'cm.member.detail.n01.lbl03' })}
          </div>
          <div className="down">{memberCode}</div>
        </Box>
        <Box className="item">
          <div className="up">
            {formatMessage({ id: 'cm.member.detail.n01.lbl04' })}
          </div>
          <div className="down"> {mobile}</div>
        </Box>
        <Box className="item">
          <div className="up">
            {formatMessage({ id: 'cm.member.detail.n01.lbl05' })}
          </div>
          <div className="down"> {level}</div>
        </Box>
      </Box>
    </Box>
  );
};
export default BaseInfomation;
